/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.getLog'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  logs: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogBeginConvo>(
          (() => ConvoDefs.logBeginConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogAcceptConvo>(
          (() => ConvoDefs.logAcceptConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogLeaveConvo>(
          (() => ConvoDefs.logLeaveConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogMuteConvo>(
          (() => ConvoDefs.logMuteConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogUnmuteConvo>(
          (() => ConvoDefs.logUnmuteConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogCreateMessage>(
          (() => ConvoDefs.logCreateMessage) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogDeleteMessage>(
          (() => ConvoDefs.logDeleteMessage) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogReadMessage>(
          (() => ConvoDefs.logReadMessage) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogAddReaction>(
          (() => ConvoDefs.logAddReaction) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogRemoveReaction>(
          (() => ConvoDefs.logRemoveReaction) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogReadConvo>(
          (() => ConvoDefs.logReadConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogAddMember>(
          (() => ConvoDefs.logAddMember) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogRemoveMember>(
          (() => ConvoDefs.logRemoveMember) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogMemberJoin>(
          (() => ConvoDefs.logMemberJoin) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogMemberLeave>(
          (() => ConvoDefs.logMemberLeave) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogLockConvo>(
          (() => ConvoDefs.logLockConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogUnlockConvo>(
          (() => ConvoDefs.logUnlockConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogLockConvoPermanently>(
          (() => ConvoDefs.logLockConvoPermanently) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogEditGroup>(
          (() => ConvoDefs.logEditGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogCreateJoinLink>(
          (() => ConvoDefs.logCreateJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogEditJoinLink>(
          (() => ConvoDefs.logEditJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogEnableJoinLink>(
          (() => ConvoDefs.logEnableJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogDisableJoinLink>(
          (() => ConvoDefs.logDisableJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogIncomingJoinRequest>(
          (() => ConvoDefs.logIncomingJoinRequest) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogApproveJoinRequest>(
          (() => ConvoDefs.logApproveJoinRequest) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogRejectJoinRequest>(
          (() => ConvoDefs.logRejectJoinRequest) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.LogOutgoingJoinRequest>(
          (() => ConvoDefs.logOutgoingJoinRequest) as any,
        ),
      ],
      false,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
